import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { SPACING } from 'constants/design-system';

import colors from 'config/colors';
import { Drawer as CustomDrawer } from 'modules/OverviewScene/Drawer';
import { AppActions, AppSelectors } from 'store/App';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { OrderSelectors } from 'store/Orders';
import { useHaveHiddenItems } from 'util/hooks/useHaveHiddenItems';
import { OrderDetailCardForStateContainer } from 'components/OrderDetailCard/OrderDetailCard';
import { OrderDetailCardMenuControlForStateContainer } from 'components/OrderDetailCard/OrderDetailCardMenuControl';
import { OrderDetailCardStateContainer } from 'components/OrderDetailCard/OrderDetailCardStateContainer';

const OverviewNavigatorComponent = () => {
  const safeAreaInsets = useSafeAreaInsets();

  const [isHiddenItemShown, setIsHiddenItemShown] = useState(false);

  const selectOrderUUID = useAppSelector(AppSelectors.selectOrderUUID);

  // TODO: refactor to not pull all orders then filter
  const order = useAppSelector((state) =>
    selectOrderUUID ? OrderSelectors.selectById(state, selectOrderUUID) : null,
  );

  const dispatch = useAppDispatch();

  const filteredItems = useAppSelector((state) =>
    order?.uuid
      ? OrderSelectors.selectItemsForOrderWithCategories(state, order?.uuid)
      : null,
  )?.filter(
    (item): item is Exclude<typeof item, undefined> => item !== undefined,
  );

  const allItems = useAppSelector((state) =>
    order?.uuid ? OrderSelectors.selectItemsForOrder(state, order?.uuid) : null,
  );

  const haveHiddenItems = useHaveHiddenItems(
    allItems ?? [],
    filteredItems ?? [],
  );

  const items = isHiddenItemShown ? allItems : filteredItems;

  return (
    <View
      style={{
        flexDirection: 'row',
        height: '100%',
        padding: SPACING.theme[10],
        gap: SPACING.theme[10],
      }}
    >
      <View
        style={{
          width: '30%',
          minWidth: 330,
          borderRightWidth: 0,
          paddingHorizontal: SPACING.theme[10],
        }}
      >
        <CustomDrawer />
      </View>
      {/* <OrderDetails /> */}
      {order && (
        <View
          style={{
            flex: 1,
            gap: SPACING.theme[6],
            marginTop: safeAreaInsets.top,
          }}
        >
          <OrderDetailCardStateContainer orderUuid={order.uuid}>
            {(state) => (
              <>
                <View style={{ paddingHorizontal: SPACING.theme[12] }}>
                  <OrderDetailCardMenuControlForStateContainer
                    {...state}
                    order={order}
                    isHiddenItemShown={isHiddenItemShown}
                    hasHiddenItems={haveHiddenItems.haveHiddenItems}
                    onPressShowHiddenItems={() => {
                      setIsHiddenItemShown((prev) => !prev);
                    }}
                    onPressClose={() => {
                      dispatch(
                        AppActions.setSelectedOrderUUID({
                          orderUUID: undefined,
                        }),
                      );
                    }}
                  />
                </View>
                <OrderDetailCardForStateContainer
                  {...state}
                  order={order}
                  items={items ?? []}
                  style={{ flexShrink: 1, minHeight: '50%' }}
                />
              </>
            )}
          </OrderDetailCardStateContainer>
        </View>
      )}
    </View>
  );
};

const OverviewNavigator = () => {
  return (
    <View style={styles.container}>
      <OverviewNavigatorComponent />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.lightBlue2,
    flex: 1,
    height: '100%',
    width: '100%',
  },
});

export default OverviewNavigator;
